import { ImageConfig } from "../models/client";
import { Color } from "../models/theme";

interface TimelineConfig {
  groups: TimelineGroupData[];
}

export interface TimelineGroupData {
  id: number;
  startDate: string;
  startPosition: "start" | "end";
  dateColor: Color;
  bgColor: Color;
  dateMoveFactor: any[];
  dateStartOffset: number;
  timelineItems: TimelineItemData[];
}

interface TimelineItemBase {
  id: number;
  gridStart?: number;
  gridSpan?: number;
  gridCol: string | string[];
  layer: number;
  height?: number | string | Array<number | string>;
  verticalOffset: number | string | Array<number | string>;
  padding?: number | string | Array<number | string>;
  marginBottom: number | string | Array<number | string>;
  parallaxFactor: any[];
  debug?: boolean;
}

export interface TimelineImageData {
  labelPosition: "t" | "b";
  labelAlignment: "start" | "end";
  image: ImageConfig;
  yearText: string;
  labelText: string;
}

export interface TimelineWatermarkData {
  image: ImageConfig;
  offset: {
    x?: number | string | Array<number | string>;
    y?: number | string | Array<number | string>;
  };
  opacity?: number | string | Array<number | string>;
}

export interface TimelineZoomData extends TimelineImageData {
  zoomFactor: number;
  xShift: number;
  yLimit: number;
  scale: Array<string>;
  rotation: Array<string>;
  x: Array<string>;
  yFactor: number;
}

interface TimelineItemImageData extends TimelineItemBase {
  type: "image";
  data: TimelineImageData;
}

interface TimelineItemWatermarkData extends TimelineItemBase {
  type: "watermark";
  data: TimelineWatermarkData;
}

interface TimelineItemZoomData extends TimelineItemBase {
  type: "zoom";
  data: TimelineZoomData;
}

export interface TimelineTextData {
  content: string;
  size?: string | Array<string>;
  weight?: number;
  // minSize: string;
  // maxSize: string;
  // variableSize: string;
}

interface TimelineItemTextData extends TimelineItemBase {
  type: "text";
  data: TimelineTextData;
}

export type TimelineItemData =
  | TimelineItemImageData
  | TimelineItemTextData
  | TimelineItemZoomData
  | TimelineItemWatermarkData;

export const timelineConfig: TimelineConfig = {
  groups: [
    {
      id: 0,
      startDate: "1841",
      startPosition: "end",
      dateColor: "blueDark",
      bgColor: "salmon",
      dateMoveFactor: [0, -100],
      dateStartOffset: 300,
      timelineItems: [
        {
          id: 10,
          gridCol: ["14 / span 10", "14 / span 10"],
          layer: 0,
          height: "0px",
          type: "watermark",
          verticalOffset: ["-40vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            image: {
              src: "/assets/images/timeline/advertisement-1898-watermark.jpg",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            offset: {
              x: "7vw",
            },
          },
        },
        {
          id: 0,
          gridCol: ["14 / span 10", "13 / span 6"],
          layer: 3,
          height: "0px",
          type: "text",
          verticalOffset: ["2vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            content:
              "Pharmacy's first professional body, the Pharmaceutical Society is established in London.",
            size: "1.8vw",
          },
        },
        {
          id: 1,
          gridStart: 7,
          gridSpan: 5,
          gridCol: ["2 / span 11", "6 / span 6"],
          layer: 2,
          height: "auto",
          type: "image",
          verticalOffset: ["-2vw", "-6vw"],
          marginBottom: 0,
          parallaxFactor: ["0%", "-10vw"],
          data: {
            labelPosition: "t",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/advertisement-1898.jpg",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            yearText: "1898",
            labelText: "Advertisement",
          },
        },
        // {
        //   id: 2,
        //   gridStart: 2,
        //   gridSpan: 21,
        //   gridCol: ["1 / span 23", "2 / span 21"],
        //   layer: 1,
        //   height: "auto",
        //   type: "zoom",
        //   verticalOffset: ["-15vw"],
        //   marginBottom: 0,
        //   parallaxFactor: ["0", "0"],
        //   data: {
        //     labelPosition: "b",
        //     labelAlignment: "start",
        //     image: {
        //       src: "/assets/images/timeline/boots-london-road-derby-store1849.jpg",
        //       title: "Image 2",
        //       width: 1920,
        //       height: 1392,
        //     },
        //     yearText: "1896",
        //     labelText: "Boots London Road, Derby store",
        //   },
        // },
        {
          id: 2,
          gridStart: 2,
          gridSpan: 21,
          gridCol: ["1 / span 23", "4 / span 17"],
          layer: 1,
          height: "auto",
          type: "zoom",
          verticalOffset: ["-15vw"],
          marginBottom: 0,
          parallaxFactor: ["0", "0"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/boots-london-road-derby-store1849.jpg",
              title: "Image 1",
              width: 1920,
              height: 1554,
            },
            yearText: "1896",
            labelText: "Boots London Road, Derby store",
            zoomFactor: 1.3,
            xShift: 200,
            yLimit: 500,
            yFactor: 0.5,
            scale: ["0.8", "1"],
            rotation: ["-0.5deg", "0deg"],
            x: ["-5vw", "0vw"],
          },
        },
        {
          id: 3,
          gridStart: 15,
          gridSpan: 6,
          gridCol: ["10 / span 15", "15 / span 6"],
          layer: 1,
          height: "auto",
          type: "image",
          verticalOffset: ["2vw", "-10vw"],
          marginBottom: ["0", "-10vw"],
          parallaxFactor: ["0vw", "-10vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/label-c1890-1910.jpg",
              title: "Image 2",
              width: 1497,
              height: 1454,
            },
            yearText: "c1890-1910",
            labelText: "Label",
          },
        },
      ],
    },
    {
      id: 1,
      startDate: "1868",
      startPosition: "start",
      dateColor: "hotPink",
      bgColor: "blueDark",
      dateMoveFactor: ["0vw", "20vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 10,
          gridCol: ["14 / span 10", "16 / span 6"],
          layer: 0,
          height: "0px",
          type: "watermark",
          verticalOffset: ["-8vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            image: {
              src: "/assets/images/timeline/label-c1890-1910_cherry_watermark.png",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            offset: {
              x: "7vw",
            },
          },
        },
        {
          id: 0,
          gridStart: 8,
          gridSpan: 6,
          gridCol: ["3 / span 15", "8 / span 6"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: "0",
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            content:
              "A register of chemists, qualified by examination to sell and dispense poisons, protects the public from “dangerous substances”",
            size: "1.5vw",
          },
        },
        {
          id: 1,
          gridStart: 3,
          gridSpan: 11,
          gridCol: ["2 / span 18", "4 / span 11"],
          layer: 1,
          height: "auto",
          type: "image",
          verticalOffset: ["5vw"],
          marginBottom: ["0px"],
          parallaxFactor: ["0vw", "-10vw"],
          debug: true,
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/store-managers-dinner-c1901.jpg",
              title: "Image 1",
              width: 1889,
              height: 1409,
            },
            yearText: "c1901",
            labelText: "Store Managers Dinner",
          },
        },
        {
          id: 2,
          gridStart: 12,
          gridSpan: 7,
          gridCol: ["6 / span 17", "13 / span 8"],
          layer: 0,
          height: "0px",
          type: "image",
          verticalOffset: ["10vw", "-25vw"],
          marginBottom: ["0px"],
          parallaxFactor: ["0vw", "-2vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/letter-to-Edwin-Waring-1874.jpg",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            yearText: "1874",
            labelText:
              "Letter from the Pharmaceutical Society to Edwin Waring, Boots first pharmacist",
          },
        },
        {
          id: 3,
          gridStart: 5,
          gridSpan: 4,
          gridCol: ["5 / span 10", "5 / span 5"],
          layer: 4,
          height: "auto",
          type: "image",
          verticalOffset: ["5vw", "-2vw"],
          marginBottom: [0, "-15vw"],
          parallaxFactor: ["0vw", "-8vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/label-c1890-1910_cherry.jpg",
              title: "Image 1",
              width: 367,
              height: 979,
            },
            yearText: "c1890-1910",
            labelText: "Label",
          },
        },
      ],
    },
    {
      id: 2,
      startDate: "1891",
      startPosition: "start",
      dateColor: "blue",
      bgColor: "green",
      dateMoveFactor: ["-15vw", "40vw"],
      dateStartOffset: -80,
      timelineItems: [
        {
          id: 10,
          gridCol: ["14 / span 10", "1 / span 6"],
          layer: 0,
          height: "0px",
          type: "watermark",
          verticalOffset: ["-8vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            image: {
              src: "/assets/images/timeline/c1900-packaging-watermark.jpg",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            offset: {},
          },
        },
        {
          id: 0,
          gridStart: 10,
          gridSpan: 6,
          gridCol: ["5 / span 10", "10 / span 6"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: 4,
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            content: "Aspirin first sold",
            size: "2.4vw",
          },
        },
        {
          id: 1,
          gridStart: 17,
          gridSpan: 4,
          gridCol: ["14 / span 8", "17 / span 4"],
          layer: 0,
          height: ["auto", "0px"],
          type: "image",
          verticalOffset: "-7vw",
          marginBottom: 0,
          parallaxFactor: ["0vw", "-10vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/c1918-aspirin-label.png",
              title: "Image 1",
              width: 338,
              height: 846,
            },
            yearText: "c1918",
            labelText: "Aspirin label",
          },
        },
        {
          id: 2,
          gridStart: 4,
          gridSpan: 14,
          gridCol: ["2 / span 21", "4 / span 14"],
          layer: 0,
          height: "auto",
          type: "image",
          verticalOffset: ["5vw", "7vw"],
          padding: [0, "0 2vw 0 0"],
          marginBottom: 0,
          parallaxFactor: ["0vw", "-5vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/c1900-packaging.jpg",
              title: "Image 1",
              width: 1500,
              height: 1031,
            },
            yearText: "c1900",
            labelText: "Packaging",
          },
        },
        {
          id: 3,
          gridStart: 12,
          gridSpan: 8,
          gridCol: ["11 / span 12", "12 / span 8"],
          layer: 0,
          height: "auto",
          type: "image",
          verticalOffset: ["-8vw"],
          marginBottom: [0, "-20vw"],
          parallaxFactor: ["0vw", "-12vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/1920s-window-display.jpg",
              title: "Image 1",
              width: 1430,
              height: 1920,
            },
            yearText: "c1920s",
            labelText: "Window display",
          },
        },
      ],
    },
    {
      id: 3,
      startDate: "1908",
      startPosition: "start",
      dateColor: "blueDark",
      bgColor: "melon",
      dateMoveFactor: ["-15vw", "15vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 0,
          gridStart: 4,
          gridSpan: 8,
          gridCol: ["3 / span 18", "4 / span 8"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: 0,
          marginBottom: "0px",
          parallaxFactor: [0, 0],
          data: {
            content:
              "The Pharmaceutical Society given greater powers to regulate pharmacy courses and examinations",
            size: "1.7vw",
          },
        },
        {
          id: 1,
          gridStart: 18,
          gridSpan: 6,
          gridCol: ["14 / span 8", "18 / span 6"],
          layer: 1,
          height: ["auto", "0px"],
          type: "image",
          verticalOffset: "-5vw",
          marginBottom: "0px",
          parallaxFactor: ["0vw", "-20vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/c1911-label.jpg",
              title: "Image 1",
              width: 451,
              height: 974,
            },
            yearText: "c1911",
            labelText: "Label",
          },
        },
        {
          id: 2,
          gridStart: 3,
          gridSpan: 14,
          gridCol: ["5 / span 14", "1 / span 23"],
          layer: 0,
          height: "auto",
          type: "zoom",
          verticalOffset: "5vw",
          marginBottom: "-8vw",
          parallaxFactor: [0, 0],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1906-syllabus.jpg",
              title: "Image 1",
              width: 1920,
              height: 1554,
            },
            yearText: "1906",
            labelText:
              "Syllabus for Jesse Boot’s pharmacy scholarship examinations",
            zoomFactor: 1.25,
            xShift: 200,
            yLimit: 500,
            yFactor: 0.5,
            scale: ["0.8", "1"],
            rotation: ["-0.5deg", "0deg"],
            x: ["-5vw", "0vw"],
          },
        },
      ],
    },
    {
      id: 4,
      startDate: "1911",
      startPosition: "end",
      dateColor: "green",
      bgColor: "blueDark",
      dateMoveFactor: ["10vw", "-40vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 10,
          gridCol: ["14 / span 10", "18 / span 6"],
          layer: 0,
          height: "0px",
          type: "watermark",
          verticalOffset: ["-12vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            image: {
              src: "/assets/images/timeline/c1912_label.png",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            offset: {},
            opacity: 0.15,
          },
        },
        {
          id: 0,
          gridStart: 12,
          gridSpan: 7,
          gridCol: ["7 / span 16", "12 / span 7"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: 0,
          marginBottom: 0,
          parallaxFactor: [0, -10],
          data: {
            content:
              "Introduction of medical insurance (national insurance contributions) for working men and women",
            size: "1.6vw",
          },
        },
        {
          id: 1,
          gridStart: 1,
          gridSpan: 6,
          gridCol: ["1 / span 13", "1 / span 6"],
          layer: 1,
          height: "auto",
          type: "image",
          verticalOffset: ["10vw", "5vw"],
          marginBottom: "-30vw",
          parallaxFactor: ["0vw", "-15vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1926-prescription.jpg",
              title: "Image 1",
              width: 942,
              height: 1202,
            },
            yearText: "1926",
            labelText: "Prescription",
          },
        },
        {
          id: 2,
          gridStart: 5,
          gridSpan: 5,
          gridCol: ["12 / span 10", "5 / span 5"],
          layer: 0,
          height: "0px",
          type: "image",
          verticalOffset: ["-15vw", "5vw"],
          marginBottom: 0,
          parallaxFactor: ["0vw", "0vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1926-prescription2.jpg",
              title: "Image 1",
              width: 754,
              height: 998,
            },
            yearText: "",
            labelText: "",
          },
        },
        {
          id: 3,
          gridStart: 11,
          gridSpan: 10,
          gridCol: ["5 / span 14", "11 / span 10"],
          layer: 0,
          height: "auto",
          type: "image",
          verticalOffset: ["45vw", "0vw"],
          marginBottom: 0,
          parallaxFactor: ["0", "-4vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1911_national_health_insurance.jpg",
              title: "Image 1",
              width: 1441,
              height: 1682,
            },
            yearText: "",
            labelText: "",
          },
        },
        {
          id: 4,
          gridStart: 15,
          gridSpan: 8,
          gridCol: ["10 / span 12", "15 / span 8"],
          layer: 1,
          height: "auto",
          type: "image",
          verticalOffset: ["-15vw"],
          marginBottom: 0,
          parallaxFactor: ["0vw", "-10vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1940s_boots_Sutton_in_ashfield_store.jpg",
              title: "Image 1",
              width: 1401,
              height: 1920,
            },
            yearText: "1940s",
            labelText: "Boots Sutton in Ashfield store",
          },
        },
        {
          id: 5,
          gridStart: 5,
          gridSpan: 5,
          gridCol: ["12 / span 12", "5 / span 5"],
          layer: 1,
          height: "0px",
          type: "image",
          verticalOffset: ["10vw", "-30vw"],
          marginBottom: 0,
          parallaxFactor: ["0vw", "-2vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/c1912_label2.png",
              title: "Image 1",
              width: 350,
              height: 630,
            },
            yearText: "",
            labelText: "",
          },
        },
        {
          id: 6,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["1 / span 12", "1 / span 5"],
          layer: 1,
          height: "auto",
          type: "image",
          verticalOffset: ["20vw", "-18vw"],
          marginBottom: ["0vw", "-20vw"],
          parallaxFactor: ["0vw", "-12vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/c1912_label.png",
              title: "Image 1",
              width: 350,
              height: 627,
            },
            yearText: "c1912",
            labelText: "Label",
          },
        },
      ],
    },
    {
      id: 5,
      startDate: "1921",
      startPosition: "end",
      dateColor: "blue",
      bgColor: "green",
      dateMoveFactor: ["0vw", "-25vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 0,
          gridStart: 12,
          gridSpan: 7,
          gridCol: ["7 / span 16", "12 / span 7"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: 0,
          marginBottom: 0,
          parallaxFactor: [0, -10],
          data: {
            content:
              "Strict controls pharmacists’ handling of “dangerous drugs” introduced in line with developing international law",
            size: "1.6vw",
          },
        },
        {
          id: 1,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 16", "2 / span 6"],
          layer: 1,
          height: "auto",
          type: "image",
          verticalOffset: ["10vw", "-15vw"],
          marginBottom: ["0vw"],
          parallaxFactor: ["0vw", "-12vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1921_light_on_law.jpg",
              title: "Image 1",
              width: 600,
              height: 1291,
            },
            yearText: "",
            labelText: "",
          },
        },
        {
          id: 2,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["9 / span 13", "18 / span 6"],
          layer: 1,
          height: ["auto", "0px"],
          type: "image",
          verticalOffset: ["2vw", "-35vw"],
          marginBottom: ["0vw"],
          parallaxFactor: ["0vw", "-12vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1933_guide.jpg",
              title: "Image 1",
              width: 610,
              height: 786,
            },
            yearText: "1933",
            labelText: "Guide",
          },
        },
        {
          id: 10,
          gridCol: ["14 / span 10", "1/ span 8"],
          layer: 0,
          height: "0px",
          type: "watermark",
          verticalOffset: ["-12vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            image: {
              src: "/assets/images/timeline/1933_guide_watermark.jpg",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            offset: {},
          },
        },
        {
          id: 3,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 19", "6 / span 11"],
          layer: 0,
          height: "auto",
          type: "image",
          verticalOffset: ["5vw", "-32vw"],
          marginBottom: ["-8vw"],
          parallaxFactor: ["0vw", "-2vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/c1908_pharmacist_hedley_riley.jpg",
              title: "Image 1",
              width: 1000,
              height: 1354,
            },
            yearText: "c1908",
            labelText: "Pharmacist Hedley Riley in Boots Ripley store",
          },
        },
      ],
    },
    {
      id: 6,
      startDate: "1930",
      startPosition: "start",
      dateColor: "blueDark",
      bgColor: "salmon",
      dateMoveFactor: ["-20vw", "20vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 10,
          gridCol: ["14 / span 10", "16/ span 8"],
          layer: 0,
          height: "0px",
          type: "watermark",
          verticalOffset: ["-12vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            image: {
              src: "/assets/images/timeline/1924_advertisement_watermark.jpg",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            offset: { x: "8vw" },
          },
        },
        {
          id: 0,
          gridStart: 12,
          gridSpan: 7,
          gridCol: ["7 / span 16", "7 / span 7"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: 0,
          marginBottom: 0,
          parallaxFactor: [0, -10],
          data: {
            content: "Insulin first used to treat Diabetes",
            size: "2.4vw",
          },
        },
        {
          id: 1,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 19", "4 / span 14"],
          layer: 0,
          height: "auto",
          type: "image",
          verticalOffset: ["5vw"],
          marginBottom: ["0vw"],
          parallaxFactor: ["0vw", "-2vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1922_thebee.jpg",
              title: "Image 1",
              width: 1400,
              height: 1886,
            },
            yearText: "",
            labelText: "",
          },
        },
        {
          id: 2,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 19", "17 / span 8"],
          layer: 0,
          height: "auto",
          type: "image",
          verticalOffset: ["-50vw"],
          marginBottom: ["0vw"],
          parallaxFactor: ["0vw", "-6vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/1930s_medical_leaflet.jpg",
              title: "Image 1",
              width: 1219,
              height: 1850,
            },
            yearText: "1930s",
            labelText: "Medical leaflet",
          },
        },
        {
          id: 3,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 19", "1 / span 8"],
          layer: 0,
          height: "auto",
          type: "image",
          verticalOffset: ["-20vw"],
          marginBottom: ["-20vw"],
          parallaxFactor: ["0vw", "-15vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1924_advertisement.jpg",
              title: "Image 1",
              width: 1000,
              height: 1434,
            },
            yearText: "1924",
            labelText: "Advertisement",
          },
        },
      ],
    },
    {
      id: 7,
      startDate: "1940",
      startPosition: "end",
      dateColor: "hotPink",
      bgColor: "melon",
      dateMoveFactor: ["12vw", "-20vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 0,
          gridStart: 12,
          gridSpan: 7,
          gridCol: ["7 / span 16", "16 / span 7"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: 0,
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            content: "Antibiotic ‘penicillin’ introduced",
            size: "2.4vw",
          },
        },
        {
          id: 1,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 19", "2 / span 12"],
          layer: 1,
          height: "auto",
          type: "image",
          verticalOffset: ["-10vw"],
          marginBottom: ["0px"],
          parallaxFactor: ["0vw", "-10vw"],
          data: {
            labelPosition: "t",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1954_manufacture_of_penicillin.jpg",
              title: "Image 1",
              width: 1500,
              height: 924,
            },
            yearText: "1954",
            labelText: "Manufacture of Penicillin",
          },
        },
        {
          id: 2,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 19", "4 / span 13"],
          layer: 0,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-10vw"],
          marginBottom: [0],
          parallaxFactor: ["0vw", "0vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/1946_pharmacy_superintendents_circular_letter.jpg",
              title: "Image 1",
              width: 1001,
              height: 1425,
            },
            yearText: "1946",
            labelText: "Pharmacy Superintendents circular letter",
          },
        },
        {
          id: 4,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 19", "15 / span 9"],
          layer: 0,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-50vw"],
          marginBottom: ["0px"],
          parallaxFactor: ["0vw", "-5vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/1946_leaflet.jpg",
              title: "Image 1",
              width: 1265,
              height: 1509,
            },
            yearText: "1946",
            labelText: "Leaflet",
          },
        },
        {
          id: 3,
          gridStart: 12,
          gridSpan: 7,
          gridCol: ["7 / span 16", "13 / span 4"],
          layer: 1,
          height: "0px",
          type: "text",
          verticalOffset: ["2vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            content:
              "Penicillin was first made available to the public on 1st June 1946, although it was only with the launch of the NHS in 1948 that it became accessible to all.",
            size: "1.4rem",
            weight: 200,
          },
        },
        {
          id: 5,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 19", "2 / span 8"],
          layer: 0,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-25vw"],
          marginBottom: ["-10vw"],
          parallaxFactor: ["0vw", "0vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1950s_penicillin_production.jpg",
              title: "Image 1",
              width: 1072,
              height: 1721,
            },
            yearText: "1950s",
            labelText: "Penicillin production",
          },
        },
        {
          id: 6,
          gridStart: 12,
          gridSpan: 7,
          gridCol: ["7 / span 16", "2 / span 8"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: ["10vw"],
          marginBottom: ["-15vw"],
          parallaxFactor: ["0vw", "0vw"],
          data: {
            content:
              "Spray guns were used to transfer spores of Penicillium Notatum into glass bottles. The bottles were then left for seven days to enable the mould to grow and generate a liquid. The liquid was then separated from the surface mass and pumped to the processing room where the penicillin was extracted.",
            size: "1.4rem",
            weight: 200,
          },
        },
      ],
    },
    {
      id: 8,
      startDate: "1941",
      startPosition: "end",
      dateColor: "green",
      bgColor: "blueDark",
      dateMoveFactor: ["0vw", "-10vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 10,
          gridCol: ["14 / span 10", "19/ span 5"],
          layer: 0,
          height: "0px",
          type: "watermark",
          verticalOffset: ["0vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            image: {
              src: "/assets/images/timeline/1941_label_gripe.png",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            offset: { x: "5vw" },
            opacity: 0.15,
          },
        },
        {
          id: 0,
          gridStart: 12,
          gridSpan: 7,
          gridCol: ["7 / span 16", "14 / span 5"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: 0,
          marginBottom: "0px",
          parallaxFactor: [0, 0],
          data: {
            content:
              "Medicines’ packaging requires clear labelling of active ingredients",
            size: "1.65vw",
          },
        },
        {
          id: 1,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 19", "6 / span 4"],
          layer: 0,
          height: ["0px"],
          type: "image",
          verticalOffset: ["-10vw"],
          marginBottom: ["0vw"],
          parallaxFactor: ["0vw", "0vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1941_label_diarrhoea.jpg",
              title: "Image 1",
              width: 408,
              height: 1178,
            },
            yearText: "",
            labelText: "",
          },
        },
        {
          id: 2,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 19", "2 / span 5"],
          layer: 1,
          height: ["auto"],
          type: "image",
          verticalOffset: ["0vw"],
          marginBottom: ["-40vw"],
          parallaxFactor: ["2vw", "-8vw"],
          padding: "0 3.5vw 0 0",
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1941_label_gripe.png",
              title: "Image 1",
              width: 300,
              height: 845,
            },
            yearText: "",
            labelText: "",
          },
        },
        {
          id: 3,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 18", "11 / span 13"],
          layer: 1,
          height: ["auto"],
          type: "image",
          verticalOffset: ["0px"],
          marginBottom: ["-5vw"],
          parallaxFactor: ["0vw", "-5vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1939_boots_newcastle_upon_tyne_store.jpg",
              title: "Image 1",
              width: 1997,
              height: 1333,
            },
            yearText: "1939",
            labelText: "Boots Newcastle upon Tyne Store",
          },
        },
      ],
    },
    {
      id: 9,
      startDate: "1948",
      startPosition: "start",
      dateColor: "blue",
      bgColor: "green",
      dateMoveFactor: ["0vw", "10vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 10,
          gridCol: ["14 / span 10", "12/ span 12"],
          layer: 0,
          height: "0px",
          type: "watermark",
          verticalOffset: ["-15vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            image: {
              src: "/assets/images/timeline/1948_display_leaflet_watermark.jpg",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            offset: { x: "15vw" },
          },
        },
        {
          id: 0,
          gridStart: 12,
          gridSpan: 7,
          gridCol: ["7 / span 16", "6 / span 6"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: 0,
          marginBottom: "0px",
          parallaxFactor: [0, 0],
          data: {
            content: "Pharmacists dispensed free prescriptions for the new NHS",
            size: "1.8vw",
          },
        },
        {
          id: 1,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 18", "6 / span 13"],
          layer: 1,
          height: ["auto"],
          type: "image",
          verticalOffset: ["5vw"],
          marginBottom: ["0px"],
          parallaxFactor: ["2vw", "-12vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1948_display_leaflet.jpg",
              title: "Image 1",
              width: 1920,
              height: 1353,
            },
            yearText: "",
            labelText: "",
          },
        },
        {
          id: 2,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 18", "12 / span 13"],
          layer: 0,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-12vw"],
          marginBottom: ["-5vw"],
          parallaxFactor: ["0vw", "4vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1948_display_leaflet2.jpg",
              title: "Image 1",
              width: 1920,
              height: 1460,
            },
            yearText: "1948",
            labelText: "Display leaflet",
          },
        },
      ],
    },
    {
      id: 10,
      startDate: "1950",
      startPosition: "start",
      dateColor: "blueDark",
      bgColor: "pinkLight",
      dateMoveFactor: ["-25vw", "15vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 0,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 18", "1 / span 9"],
          layer: 1,
          height: ["auto", "0px"],
          type: "image",
          verticalOffset: ["-10vw"],
          marginBottom: ["2vw"],
          parallaxFactor: ["2vw", "-10vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1950s_leaflet.jpg",
              title: "Image 1",
              width: 1920,
              height: 1460,
            },
            yearText: "1950s",
            labelText: "Leaflet",
          },
        },
        {
          id: 1,
          gridStart: 12,
          gridSpan: 7,
          gridCol: ["7 / span 16", "14 / span 7"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: 0,
          marginBottom: "0px",
          parallaxFactor: [0, 0],
          data: {
            content: "First patient treated with cortisone",
            size: "2.2vw",
          },
        },
        {
          id: 2,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 18", "9 / span 15"],
          layer: 0,
          height: ["auto"],
          type: "image",
          verticalOffset: ["5vw"],
          marginBottom: ["2vw"],
          parallaxFactor: ["0vw", "4vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/1954_manufacture_of_cortisone.jpg",
              title: "Image 1",
              width: 1500,
              height: 982,
            },
            yearText: "1954",
            labelText: "Manufacture of cortisone",
          },
        },
        {
          id: 3,
          gridStart: 1,
          gridSpan: 5,
          gridCol: ["2 / span 18", "3 / span 13"],
          layer: 1,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-5vw"],
          marginBottom: ["-4vw"],
          parallaxFactor: ["0vw", "-4vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1960s_display.jpg",
              title: "Image 1",
              width: 1500,
              height: 1140,
            },
            yearText: "1960s",
            labelText:
              "Display charting the manufacture of cortisone using extracts from the plant Dioscorea Sylvatica, also known as Elephant’s Foot",
          },
        },
        {
          id: 10,
          gridCol: ["14 / span 10", "12/ span 12"],
          layer: 0,
          height: "0px",
          type: "watermark",
          verticalOffset: ["-30vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            image: {
              src: "/assets/images/timeline/1950s_leaflet_watermark.png",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            offset: { x: "15vw" },
          },
        },
      ],
    },
    {
      id: 11,
      startDate: "1952",
      startPosition: "start",
      dateColor: "blue",
      bgColor: "salmon",
      dateMoveFactor: ["0vw", "25vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 0,
          gridStart: 12,
          gridSpan: 7,
          gridCol: ["7 / span 16", "7 / span 7"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: 0,
          marginBottom: "0px",
          parallaxFactor: [0, 0],
          data: {
            content: "Prescription charges introduced",
            size: "2.2vw",
          },
        },
        {
          id: 1,
          gridCol: ["2 / span 18", "20 / span 4"],
          layer: 0,
          height: ["auto", "0px"],
          type: "image",
          verticalOffset: ["-5vw"],
          marginBottom: ["-4vw"],
          parallaxFactor: ["0vw", "-4vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1950s_label.png",
              title: "Image 1",
              width: 400,
              height: 534,
            },
            yearText: "1950s",
            labelText: "Label",
          },
        },
        {
          id: 10,
          gridCol: ["14 / span 10", "14/ span 8"],
          layer: -1,
          height: "0px",
          type: "watermark",
          verticalOffset: ["10vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            image: {
              src: "/assets/images/timeline/1951_pharmaceutical_own_brand_preparations_watermark.jpg",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            offset: { x: "0vw" },
          },
        },
        {
          id: 2,
          gridCol: ["2 / span 18", "4 / span 12"],
          layer: 0,
          height: ["auto"],
          type: "image",
          verticalOffset: ["5vw"],
          marginBottom: ["-4vw"],
          parallaxFactor: ["0vw", "2vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1951_pharmaceutical_own_brand_preparations.jpg",
              title: "Image 1",
              width: 1151,
              height: 1500,
            },
            yearText: "1951",
            labelText:
              "Selection of over-the-counter and pharmaceutical own brand preparations, Boots Annual Report",
          },
        },
        {
          id: 3,
          gridCol: ["2 / span 18", "15 / span 8"],
          layer: 0,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-25vw"],
          marginBottom: ["-9vw"],
          parallaxFactor: ["0vw", "-8vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1951_dispensary.jpg",
              title: "Image 1",
              width: 1151,
              height: 1500,
            },
            yearText: "1950s",
            labelText: "Unknown Boots store",
          },
        },
      ],
    },
    {
      id: 12,
      startDate: "1961",
      startPosition: "start",
      dateColor: "hotPink",
      bgColor: "melon",
      dateMoveFactor: ["0vw", "10vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 0,
          gridCol: ["2 / span 18", "13 / span 10"],
          layer: 1,
          height: ["0px"],
          type: "image",
          verticalOffset: ["-12vw"],
          marginBottom: ["-5vw"],
          parallaxFactor: ["0vw", "-8vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1960s_moss_chemists_hayes_store.jpg",
              title: "Image 1",
              width: 1500,
              height: 1116,
            },
            yearText: "1960s",
            labelText: "Moss Chemists Hayes store",
          },
        },
        {
          id: 1,
          gridStart: 12,
          gridSpan: 7,
          gridCol: ["7 / span 16", "6 / span 6"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: "0px",
          marginBottom: "0vw",
          parallaxFactor: [0, 0],
          data: {
            content:
              "The contraceptive pill first available on the NHS “for married women”",
            size: "1.7vw",
          },
        },
        {
          id: 2,
          gridStart: 3,
          gridSpan: 14,
          gridCol: ["5 / span 14", "2 / span 21"],
          layer: 0,
          height: "auto",
          type: "zoom",
          verticalOffset: "5vw",
          marginBottom: "0px",
          parallaxFactor: [0, 0],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1975_pharmacy_superintendents_circular_letter.jpg",
              title: "Image 1",
              width: 1064,
              height: 385,
            },
            yearText: "1975",
            labelText: "Pharmacy Superintendent's circular letter",
            zoomFactor: 1.25,
            xShift: -200,
            yLimit: 500,
            yFactor: 0.15,
            scale: ["0.8", "1"],
            rotation: ["0.5deg", "0deg"],
            x: ["5vw", "0vw"],
          },
        },
        {
          id: 3,
          gridCol: ["2 / span 18", "12 / span 9"],
          layer: 0,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-5vw"],
          marginBottom: ["-12vw"],
          parallaxFactor: ["0vw", "-8vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/c1975_boots_birmingham_store.jpg",
              title: "Image 1",
              width: 1500,
              height: 1133,
            },
            yearText: "c1975",
            labelText: "Boots Birmingham store",
          },
        },
      ],
    },
    {
      id: 13,
      startDate: "1967",
      startPosition: "start",
      dateColor: "green",
      bgColor: "blueDark",
      dateMoveFactor: ["0vw", "10vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 10,
          gridCol: ["14 / span 10", "19/ span 5"],
          layer: -1,
          height: "0px",
          type: "watermark",
          verticalOffset: ["-5vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            image: {
              src: "/assets/images/timeline/1970s_label.png",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            offset: { x: "6vw" },
            opacity: 0.1,
          },
        },
        {
          id: 0,
          gridCol: ["7 / span 16", "11 / span 6"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: "0px",
          marginBottom: "0vw",
          parallaxFactor: [0, 0],
          data: {
            content:
              "Pharmacy degrees mandatory, replacing diploma qualification for pharmacists",
            size: "1.7vw",
          },
        },
        {
          id: 1,
          gridCol: ["2 / span 18", "12 / span 7"],
          layer: 1,
          height: ["auto"],
          type: "image",
          verticalOffset: ["5vw"],
          marginBottom: ["-7vw"],
          parallaxFactor: ["0vw", "-8vw"],
          data: {
            labelPosition: "t",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/1973_booklet.jpg",
              title: "Image 1",
              width: 1200,
              height: 1336,
            },
            yearText: "1973",
            labelText: "Booklet",
          },
        },
        {
          id: 2,
          gridCol: ["2 / span 18", "4 / span 4"],
          layer: 0,
          height: ["0px"],
          type: "image",
          verticalOffset: ["-20vw"],
          marginBottom: ["0px"],
          parallaxFactor: ["-4vw", "4vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/1970s_label.png",
              title: "Image 1",
              width: 300,
              height: 596,
            },
            yearText: "1970s",
            labelText: "Label",
          },
        },
        {
          id: 3,
          gridCol: ["2 / span 18", "11 / span 10"],
          layer: 0,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-5vw"],
          marginBottom: ["-8vw"],
          parallaxFactor: ["-4vw", "2vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/c1975_boots_birmingham_store2.jpg",
              title: "Image 1",
              width: 1500,
              height: 1129,
            },
            yearText: "c1975",
            labelText: "Boots Birmingham store",
          },
        },
      ],
    },
    {
      id: 14,
      startDate: "1969",
      startPosition: "start",
      dateColor: "blue",
      bgColor: "pinkLight",
      dateMoveFactor: ["-15vw", "30vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 0,
          gridCol: ["7 / span 16", "9 / span 7"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: "0px",
          marginBottom: "0vw",
          parallaxFactor: [0, 0],
          data: {
            content:
              "Ibuprofen developed and launched as prescription medicine by Boots",
            size: "1.65vw",
          },
        },
        {
          id: 1,
          gridCol: ["2 / span 18", "17 / span 5"],
          layer: 0,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-3vw"],
          marginBottom: ["0px"],
          parallaxFactor: ["0vw", "-8vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/c1969_packaging.jpg",
              title: "Image 1",
              width: 589,
              height: 682,
            },
            yearText: "c1969",
            labelText: "Packaging",
          },
        },
        {
          id: 2,
          gridCol: ["2 / span 18", "3 / span 6"],
          layer: 0,
          height: ["0px"],
          type: "image",
          verticalOffset: ["-18vw"],
          marginBottom: ["0px"],
          parallaxFactor: ["0vw", "-2vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1969_leaflet.jpg",
              title: "Image 1",
              width: 1211,
              height: 1949,
            },
            yearText: "1969",
            labelText: "Leaflet",
          },
        },
        {
          id: 3,
          gridCol: ["2 / span 18", "8 / span 7"],
          layer: 1,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-8vw"],
          marginBottom: ["-8vw"],
          parallaxFactor: ["0vw", "-10vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/1969_advertisement.jpg",
              title: "Image 1",
              width: 1500,
              height: 2053,
            },
            yearText: "1969",
            labelText: "Advertisement",
          },
        },
        {
          id: 10,
          gridCol: ["14 / span 10", "15/ span 9"],
          layer: -1,
          height: "0px",
          type: "watermark",
          verticalOffset: ["-25vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            image: {
              src: "/assets/images/timeline/1969_advertisement_watermark.jpg",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            offset: { x: "7vw" },
            opacity: 1,
          },
        },
      ],
    },
    {
      id: 15,
      startDate: "1982",
      startPosition: "start",
      dateColor: "blueDark",
      bgColor: "green",
      dateMoveFactor: ["-20vw", "20vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 0,
          gridCol: ["2 / span 18", "16 / span 8"],
          layer: 2,
          height: ["0px"],
          type: "image",
          verticalOffset: ["-5vw"],
          marginBottom: ["0px"],
          parallaxFactor: ["0vw", "-5vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/1980_pharmacy_display_banner.png",
              title: "Image 1",
              width: 1000,
              height: 326,
            },
            yearText: "1980s",
            labelText: "Pharmacy display banner",
          },
        },
        {
          id: 1,
          gridCol: ["7 / span 16", "4 / span 8"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: "2vw",
          marginBottom: "0vw",
          parallaxFactor: [0, 0],
          data: {
            content:
              "Ask Your Pharmacist campaign promotes the role of community pharmacists in primary healthcare",
            size: "1.8vw",
          },
        },
        {
          id: 10,
          gridCol: ["14 / span 10", "15/ span 9"],
          layer: -1,
          height: "0px",
          type: "watermark",
          verticalOffset: ["0vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            image: {
              src: "/assets/images/timeline/ask.png",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            offset: { x: "10vw" },
            opacity: 1,
          },
        },
        {
          id: 2,
          gridCol: ["2 / span 18", "4 / span 12"],
          layer: 1,
          height: ["0px"],
          type: "image",
          verticalOffset: ["2vw"],
          marginBottom: ["0px"],
          parallaxFactor: ["-1vw", "2vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/c1987_boots_north_finchley_store.jpg",
              title: "Image 1",
              width: 1500,
              height: 1379,
            },
            yearText: "c1987",
            labelText: "Boots North Finchley store",
          },
        },
        {
          id: 3,
          gridCol: ["2 / span 18", "11 / span 9"],
          layer: 1,
          height: ["auto"],
          type: "image",
          verticalOffset: ["20vw"],
          marginBottom: ["-3vw"],
          parallaxFactor: ["20vw", "-15vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/2008_customer_leaflet.jpg",
              title: "Image 1",
              width: 849,
              height: 1157,
            },
            yearText: "2008",
            labelText: "Customer leaflet",
          },
        },
      ],
    },
    {
      id: 16,
      startDate: "1985",
      startPosition: "start",
      dateColor: "blue",
      bgColor: "melon",
      dateMoveFactor: ["-20vw", "30vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 0,
          gridCol: ["7 / span 16", "10 / span 10"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: "0vw",
          marginBottom: "0vw",
          parallaxFactor: [0, 0],
          data: {
            content:
              "New restrictions in prescribing removes Lucozade, Lypsyl, Nescafe instant coffee and other household items from the prescription medicines list",
            size: "1.7vw",
          },
        },
        {
          id: 1,
          gridCol: ["5 / span 14", "2 / span 21"],
          layer: 0,
          height: "auto",
          type: "zoom",
          verticalOffset: "5vw",
          marginBottom: "0px",
          parallaxFactor: [0, 0],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/1985_pharmacy_superintendents_circular_letter.jpg",
              title: "Image 1",
              width: 1920,
              height: 1505,
            },
            yearText: "1985",
            labelText: "Pharmacy Superintendent's circular letter",
            zoomFactor: 1.25,
            xShift: -200,
            yLimit: 500,
            yFactor: 0.15,
            scale: ["0.7", "1"],
            rotation: ["-0.3deg", "0deg"],
            x: ["-7vw", "0vw"],
          },
        },
        {
          id: 2,
          gridCol: ["2 / span 18", "11 / span 9"],
          layer: 1,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-5vw"],
          marginBottom: ["0vw"],
          parallaxFactor: ["0vw", "-10vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/1980s_boots_smethwick_store.jpg",
              title: "Image 1",
              width: 1500,
              height: 1070,
            },
            yearText: "1980s",
            labelText: "Boots Smethwick store",
          },
        },
        {
          id: 3,
          gridCol: ["2 / span 18", "7 / span 9"],
          layer: 0,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-15vw"],
          marginBottom: ["-2vw"],
          parallaxFactor: ["0vw", "-2vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/c1982_poster.jpg",
              title: "Image 1",
              width: 1000,
              height: 1219,
            },
            yearText: "c1982",
            labelText: "Poster",
          },
        },
      ],
    },
    {
      id: 17,
      startDate: "2005",
      startPosition: "start",
      dateColor: "hotPink",
      bgColor: "blueDark",
      dateMoveFactor: ["-25vw", "10vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 0,
          gridCol: ["7 / span 16", "8 / span 6"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: "0vw",
          marginBottom: "0vw",
          parallaxFactor: [0, 0],
          data: {
            content: "Electronic prescription service launched in England",
            size: "1.7vw",
          },
        },
        {
          id: 1,
          gridCol: ["2 / span 18", "14 / span 7"],
          layer: 1,
          height: ["0px"],
          type: "image",
          verticalOffset: ["-12vw"],
          marginBottom: ["-2vw"],
          parallaxFactor: ["0vw", "-5vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "end",
            image: {
              src: "/assets/images/timeline/2008_leaflet.jpg",
              title: "Image 1",
              width: 1701,
              height: 2425,
            },
            yearText: "2008",
            labelText: "Leaflet",
          },
        },
        {
          id: 2,
          gridCol: ["2 / span 18", "6 / span 9"],
          layer: 0,
          height: ["auto"],
          type: "image",
          verticalOffset: ["5vw"],
          marginBottom: ["-2vw"],
          parallaxFactor: ["0vw", "2vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/2012_leaflet.jpg",
              title: "Image 1",
              width: 1500,
              height: 2139,
            },
            yearText: "2012",
            labelText: "Leaflet",
          },
        },
        {
          id: 3,
          gridCol: ["2 / span 18", "12 / span 12"],
          layer: 0,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-20vw"],
          marginBottom: ["-7vw"],
          parallaxFactor: ["0vw", "-10vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/2019_boots_covent_garden_store.jpg",
              title: "Image 1",
              width: 1266,
              height: 843,
            },
            yearText: "2019",
            labelText: "Boots Covent Garden store",
          },
        },
      ],
    },
    {
      id: 18,
      startDate: "2020",
      startPosition: "start",
      dateColor: "blue",
      bgColor: "salmon",
      dateMoveFactor: ["-30vw", "30vw"],
      dateStartOffset: 0,
      timelineItems: [
        {
          id: 0,
          gridCol: ["7 / span 16", "11 / span 8"],
          layer: 1,
          height: "auto",
          type: "text",
          verticalOffset: "0vw",
          marginBottom: "0vw",
          parallaxFactor: [0, 0],
          data: {
            content:
              "Covid 19 pandemic heralds new services such as video consultations",
            size: "1.8vw",
          },
        },
        {
          id: 1,
          gridCol: ["2 / span 18", "11 / span 13"],
          layer: 0,
          height: ["0px"],
          type: "image",
          verticalOffset: ["4vw"],
          marginBottom: ["-2vw"],
          parallaxFactor: ["0vw", "-2vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/2020_covid19.jpg",
              title: "Image 1",
              width: 1500,
              height: 1000,
            },
            yearText: "2020",
            labelText: "Video consultations",
          },
        },
        {
          id: 2,
          gridCol: ["2 / span 18", "1 / span 9"],
          layer: 1,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-2vw"],
          marginBottom: ["-2vw"],
          parallaxFactor: ["0vw", "-8vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/2020_leaflet.jpg",
              title: "Image 1",
              width: 1500,
              height: 2141,
            },
            yearText: "2020",
            labelText: "Leaflet",
          },
        },
        {
          id: 10,
          gridCol: ["14 / span 10", "17/ span 7"],
          layer: -1,
          height: "0px",
          type: "watermark",
          verticalOffset: ["-15vw"],
          marginBottom: 0,
          parallaxFactor: [0, 0],
          data: {
            image: {
              src: "/assets/images/timeline/2020_watermark.png",
              title: "Image 1",
              width: 1157,
              height: 1895,
            },
            offset: { x: "3.2vw" },
            opacity: 1,
          },
        },
        {
          id: 3,
          gridCol: ["2 / span 18", "6 / span 13"],
          layer: 0,
          height: ["auto"],
          type: "image",
          verticalOffset: ["-7vw"],
          marginBottom: ["5vw"],
          parallaxFactor: ["-2vw", "0vw"],
          data: {
            labelPosition: "b",
            labelAlignment: "start",
            image: {
              src: "/assets/images/timeline/2020_covid19_vaccine.jpg",
              title: "Image 1",
              width: 1500,
              height: 2141,
            },
            yearText: "2021",
            labelText: "Boots pharmacist preparing a COVID-19 vaccination",
          },
        },
      ],
    },
  ],
};
